export const state = {
  history: [],
  isLoading: true
};
